import * as math from "mathjs";
/**
 * Energy Units Utility Module
 */

/**
 * Automatically determines the best fit for energy units
 * @param {*} value the number in wh
 */
export const determineBestUnit = value => {
  let units = ["Wh", "kWh", "MWh", "GWh", "TWh"];
  const converted = units.map(u => ({
    unit: u,
    value: math
      .unit(value, "Wh")
      .to(u)
      .toNumber()
  }));
  const { unit } =
    converted.filter(e => e.value > 1 && e.value < 1000)[0] || {};
  return unit ? unit : "kWh";
};

/**
 * auto formats the energy value based on the best unit
 * @param {*} value the number in wh
 */
export const autoFormatEnergyValue = value => {
  const unit = determineBestUnit(value);
  const num = math
    .unit(value, "Wh")
    .to(unit)
    .toJSON();
  return `${parseFloat(num.value)
    .toFixed(2)
    .toLocaleString()}  ${num.unit}`;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/component-lib/src/utilities/EnergyUnits/index.js
// module id = hWIe
// module chunks = 3